import { render, staticRenderFns } from "./PTimePicker.vue?vue&type=template&id=9ddfca2a"
import script from "./PTimePicker.vue?vue&type=script&lang=js"
export * from "./PTimePicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports